export default __webpack_public_path__ + "static/media/IMG_9062 copie.e6afed25.jpg";